// extracted by mini-css-extract-plugin
export default {"textfield":"teacher_textfield__yvmZU","scrollable":"teacher_scrollable__f4k1-"};